import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {BaseNamedRouterLinkDirective} from '@aviary/directives/base-named-router-link.directive';
import {ROUTE_NAME_CAPABLE_BUTTON_COMPONENT} from '@aviary/injection-tokens/aviary-only.tokens';
import {MatTooltip} from '@angular/material/tooltip';
import {NgTemplateOutlet} from '@angular/common';
import {RoundButtonComponent} from '@aviary/buttons/base/round-button/round-button.component';

@Component({
  selector: 'mx-icon-button',
  templateUrl: './icon-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {provide: ROUTE_NAME_CAPABLE_BUTTON_COMPONENT, useExisting: IconButtonComponent}
  ],
  imports: [MatIconButton, MatIcon, BaseNamedRouterLinkDirective, MatTooltip, NgTemplateOutlet]
})
export class IconButtonComponent extends RoundButtonComponent {
  // See BaseButtonComponent and RoundButtonComponent for the rest of the available inputs.
  @Input() public color: string = this.config.defaultColors.icon;
  @Input() public showStatusDot: boolean = false;
}
